import { AlignmentType, BorderStyle, HeadingLevel, ImageRun, Paragraph, ShadingType, Table, TableCell, TableRow, TextRun, TextWrappingSide, TextWrappingType, VerticalAlign, WidthType } from "docx";

export const frameworkNetwork = new Paragraph({
    spacing: { before: 250, after: 100 },
    children: [new TextRun({
        text: "6.1   Framework",
        bold: true,
        size: 22,
        color: "c00000",
        font: "Cambria (Headings)",
        bold: true,
        italics: false
    })],
})

export function frameworkTextNetwork(certInNetworkCustomerName){
    return new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 250, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: `ISECURION used OSSTMM and NIST frameworks to execute the vulnerability assessment and penetration testing of the ${certInNetworkCustomerName}`,
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})}

export const toolsNetwork = new Paragraph({
    spacing: { before: 450, after: 300 },
    children: [new TextRun({
        text: "6.2   Tools",
        bold: true,
        size: 22,
        color: "c00000",
        font: "Cambria (Headings)",
        bold: true,
        italics: false
    })],
})

export const toolsTableNetwork = new Table({
    width: { size: 100, type: WidthType.PERCENTAGE },
    alignment: AlignmentType.CENTER,
    spacing: { before: 450 },
    borders: {
        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
    },
    rows: [
        new TableRow({
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    width: { size: 30, type: WidthType.PERCENTAGE },
                    children: [
                        new Paragraph({
                            spacing: { before: 110, after: 110 },
                            indent:{left:60},
                            alignment: AlignmentType.LEFT,
                            children: [
                                new TextRun({
                                    text: "Vulnerability Scanners",
                                    font: "Calibri",
                                    size: 22,
                                    color: "000000",
                                    bold: true,
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "DDD9C3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                }),

                new TableCell({
                    width: { size: 70, type: WidthType.PERCENTAGE },
                    verticalAlign: VerticalAlign.LEFT,
                    children: [
                        new Paragraph({
                            spacing: { before: 110, after: 110 },
                            indent:{left:60},
                            alignment: AlignmentType.LEFT,
                            children: [
                                new TextRun({
                                    text: "Nessus Professional",
                                    font: "Calibri",
                                    size: 22,
                                    color: "000000",
                                    bold: false,
                                    italics: false
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "C6D9F1" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                }),
            ]
        }),

        new TableRow({
            children: [
                new TableCell({
                    children: [
                        new Paragraph({
                            spacing: { before: 110, after: 110 },
                            indent:{left:60},
                            alignment: AlignmentType.LEFT,
                            children: [
                                new TextRun({
                                    text: "Network Discovery",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false,
                                    bold:true
                                })
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "DDD9C3" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                }),

                new TableCell({
                    children: [
                        new Paragraph({
                            indent:{left:60},
                            spacing: { before: 110, after: 110 },
                            alignment: AlignmentType.LEFT,
                            children: [
                                new TextRun({
                                    text: "Nmap",
                                    font: "Calibri",
                                    size: 22,
                                    color: '000000',
                                    italics: false
                                }),
                            ]
                        })],
                    shading: { type: ShadingType.SOLID, color: "C6D9F1" },
                    borders: {
                        top: { style: BorderStyle.SINGLE, size: 1, color: "ffffff", },
                        bottom: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        left: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                        right: { style: BorderStyle.SINGLE, size: 1, color: "ffffff" },
                    },
                }),
            ]
        }),
    ]
})
